<template>
  <main>
    <PageHeader page-title="My Account" />

    <FormGenerator :fieldsets="data.formGenerator.fields.fieldsets" :prefill="prefill" novalidate @submitted="handleSubmit" />
  </main>
</template>

<script>
import dummyData from '@/dummy/my-account.json'

import PageHeader from '@/sections/page-header/PageHeader.vue'
import FormGenerator from '@/components/form/FormGenerator.vue'
import MeService from '@/services/MeService'
import CountryService from '@/services/CountryService'
import HttpError from '@/objects/Exceptions/HttpError'


// TODO: Get form data and post it to the backend for pre-check-in

export default {
  components: {
    PageHeader,
    FormGenerator
  },
  data () {
    return {
      data: dummyData,
      prefill: {}
    }
  },
  methods: {
    handleSubmit(formData) {
      console.log('formData', formData)
      const payload = {
        FirstName: formData.first_name,
        LastName: formData.last_name,
        Title: formData.title,
        NationalityCode: formData.nationality,
        BirthDate: formData.date_of_birth,
        BirthPlace: formData.birth_place,
        Email: formData.email,
        Gender: formData.gender,
        Phone: formData.phone
      }

      MeService.updateUserInfo(payload)
        .then((response) => {
          if (response.status != 'failed') {
            this.$notify({
              group: 'app',
              type: 'success',
              title: 'Thank you',
              text: 'Your information is updated',
              closeOnClick: true,
              duration: 5000
            })
            return true
          }
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'There is a problem',
            text: response.message,
            closeOnClick: true,
            duration: -1
          })
        }).catch((error) => {
          let errors = []
          if(error.data && error.data.errors) {
            for (const key in error.data.errors) {
              errors.push(error.data.errors[key].join(' '))
            }
          }
          this.$notify({
            group: 'app',
            type: 'error',
            title: error.data.message,
            text: errors.join(' '),
            closeOnClick: true,
            duration: -1
          })
      })
    },
    getCountries(){
      CountryService.getCountries()
          .then((response) => {
            this.data.formGenerator.fields.fieldsets[0]['inputs'][6]['options'] = response.data
          }).catch((error) => {
            throw HttpError.parseError(error)
        })

    }
  },
  mounted () {
    this.getCountries()
  },
  async created () {
    this.prefill = {...this.$store.state.userprofile.profile}
    // await this.$store.dispatch('reservations/getReservations')
  }
}
</script>
